module.exports = __webpack_public_path__ + "static/media/ryan.e6c933e1.jpeg";